import { initializeApp } from 'firebase/app';
//import { getAuth, onAuthStateChanged} from 'firebase/auth';
import { isSupported, onMessage, getToken, getMessaging } from 'firebase/messaging';
import {Environment} from '../data/Environment';

var instance:NotificationsService = null;

export class NotificationsService {

    app:any=null

    constructor(config:any={}) {
        if (!instance) {
            instance = this;
        }

        return instance;
    }

public init(): void {
//    firebase.initializeApp(Environment.firebase);
    if (this.app === null) {
        this.app = initializeApp(Environment.firebase)
    }
    // this.auth = getAuth(this.app);
    // console.log("pass 3");

    // onAuthStateChanged(this.auth, user => {
    //     console.log("user:"+user)
    //     for(var a in this.auth) {
    //         console.log("auth:"+a+":"+this.auth)
    //     }
    // })    
   
}

public async register(): Promise<void> {

    return new Promise<void>((resolve, reject) => {

        navigator.serviceWorker.ready.then((registration) => {
            //alert("sw.ready()");
            // Don't crash an error if messaging not supported
            //if (!firebase.messaging.isSupported()) {
            if (!isSupported()) {
                //alert("messaging not supported");
                resolve();
                return;
            }
//            console.log("serviceWorker.ready()");

            //const messaging = firebase.messaging();
            const messaging = getMessaging(this.app);
            // Register the Service Worker
            //messaging.useServiceWorker(registration);

            // // Initialize your VAPI
            // messaging.usePublicVapidKey(
              //     Environment.firebase.vapidKey
            // );

            // messaging.requestPermission();

            // messaging.getToken(Environment.firebase).then((token) => { 
            //     //alert(token);
            // });

            // Optional and not covered in the article
            // Listen to messages when your app is in the foreground
//            messaging.onMessage((payload:any) => {
            onMessage(messaging, (payload:any) => {
                console.log("onMessage()");
                console.log(payload);
                // alert(payload);
                // var noti = payload.notification;
                // for(var a in noti) {
                //      alert("-"+a+":"+noti[a]);
                // }
                const title = payload.notification.title;
                const options = {
                    body: payload.notification.body,
//                    icon: payload.notification.icon,
                    actions: [
                        {
//                            action: payload.fcmOptions.link,
                            action: 'http://www.google.co.th',
                            title: 'Open Google'
                        }
                    ]
                };

                registration.showNotification(title, options);           
            });

        //     var t = getToken(messaging, 
        //         {
        //             serviceWorkerRegistration:registration,
        //             vapidKey:Environment.firebase.vapidKey
        //         });
            
        //     t.then(value => {
        //         console.log("value:"+value);
        //         const options = {
        //             body: "aaabbb",
        //                 actions: [
        //                     {
        // //                            action: payload.fcmOptions.link,
        //                         action: 'http://www.google.co.th?ddd='+value,
        //                         title: 'Open Google'
        //                     }
        //                 ]
        //             }
        //             registration.showNotification("Token", options)
        //         }).catch(reason => {console.log("reason:"+reason)})

            // Optional and not covered in the article
            // Handle token refresh
            // messaging.onTokenRefresh(() => {
            //     messaging.getToken().then(
            //     (refreshedToken: string) => {
            //         console.log(refreshedToken);
            //     }).catch((err:any) => {
            //         console.error(err);
            //     });
            // });

            //alert("init finish");

            resolve();
        }, (err: any) => {
            alert("regis error:"+err)
            reject(err);
        });
    });
  }

//   public async requestPermission(): Promise<void> {
//     return new Promise<void>(async (resolve) => {
//         if (!Notification) {
//             resolve();
//             return;
//         }
//         if (!firebase.messaging.isSupported()) {
//             resolve();
//             return;
//         }
//         try {
//             const messaging = firebase.messaging();

//             await messaging.requestPermission();

//             const token: string = await messaging.getToken();

//             console.log('User notifications token:', token);
//             alert(token);
//         } catch (err) {
//             console.log("err:"+err);
//             // No notifications granted
//         }

//         resolve();
//     });
//     }

    public async getToken(): Promise<string> {
        return getToken(getMessaging(this.app), 
                    {
                        vapidKey:Environment.firebase.vapidKey
                    }
        );
    }
}
